import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TopNavbar from "../../../../components/TopNavbar";
import SideNavbar from "../../../../components/SideNavbar";
import { useAppSelector } from '../../../../redux/store';

const PayoutsAccounts = () => {
    const isCollapsed = useAppSelector(state => state.sidebar.isCollapsed);
    const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState("Payouts");

    const sections = ["Invoices", "Payouts", "Invoice List"];
    const handleSectionClick = (section: string) => {
        setActiveSection(section);
        switch (section) {
            case "Invoices":
                navigate("/accounts");
                break;
            case "Payouts":
                navigate("/accounts/payouts");
                break;
            case "Invoice List":
                navigate("/accounts/invoicelist");
                break;
            default:
                break;
        }
    };

    const remittanceData = [
        {
            transactionDate: "2025-01-01",
            customerName: "John Doe",
            currencyName: "USD",
            fxCurrencyRemitted: "1000",
            transactionValue: "75000",
            margin: "2000",
            agentProfit: "500",
        },
        {
            transactionDate: "2025-01-02",
            customerName: "Jane Smith",
            currencyName: "EUR",
            fxCurrencyRemitted: "800",
            transactionValue: "64000",
            margin: "1500",
            agentProfit: "400",
        },
        {
            transactionDate: "2025-01-02",
            customerName: "Jane Smith",
            currencyName: "EUR",
            fxCurrencyRemitted: "800",
            transactionValue: "64000",
            margin: "1500",
            agentProfit: "400",
        },
        {
            transactionDate: "2025-01-02",
            customerName: "Jane Smith",
            currencyName: "EUR",
            fxCurrencyRemitted: "800",
            transactionValue: "64000",
            margin: "1500",
            agentProfit: "400",
        },
    ];

    const accommodationData = [
        {
            dateOfBooking: "2025-01-02",
            customerName: "Jane Smith",
            country: "EUR",
            fxCurrencyRemitted: "800",
            transactionValue: "64000",
            margins: "1500",
            agentProf: "400",
        },
        {
            dateOfBooking: "2025-01-02",
            customerName: "Jane Smith",
            country: "EUR",
            fxCurrencyRemitted: "800",
            transactionValue: "64000",
            margins: "1500",
            agentProf: "400",
        },
        {
            dateOfBooking: "2025-01-02",
            customerName: "Jane Smith",
            country: "EUR",
            fxCurrencyRemitted: "800",
            transactionValue: "64000",
            margins: "1500",
            agentProf: "400",
        },

    ];
    const tableClass = "font-base font-normal p-2 text-zinc-100 font-Montserrat";
    const rowClass = "font-base font-normal p-2 text-neutral-600 text-center font-Montserrat";
    return (
        <div className="min-h-screen bg-gray-200">
            {/* <div className="fixed top-0 left-0 w-full z-20">
                <TopNavbar />
            </div> */}
            <div className="fixed top-16 left-0 h-full z-10">
                <SideNavbar />
            </div>
            <div className={`${isCollapsed ? 'ml-[70px]' : 'ml-[290px]'} mt-[109px] p-8 transition-all duration-300`}>
                <div className="bg-white p-6 rounded-3xl shadow-md w-full min-h-screen flex flex-col">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                            <div className="flex items-center justify-center w-12 h-12 rounded-full"
                                style={{ background: "linear-gradient(180deg, #00A6D9 10%, #3483BE 100%)", }}>
                                <img src={`${process.env.PUBLIC_URL}/images/desktop/basil_invoice-outline.svg`}
                                    alt="Icon" className="w-7 h-7" />
                            </div>
                            {sections.map((section) => (
                                <h2 key={section}
                                    onClick={() => handleSectionClick(section)}
                                    className={`font-montserrat text-lg font-medium cursor-pointer ${activeSection === section
                                            ? "text-gray-900" : "text-stone-300"}`}
                                    style={{
                                        borderBottom: activeSection === section ? "2px solid transparent" : "none",
                                        backgroundImage: activeSection === section
                                            ? "linear-gradient(180deg, #00A6D9 0%, #3483BE 100%)" : "none", backgroundPosition: "bottom",
                                        backgroundSize: "100% 2px",
                                        backgroundRepeat: "no-repeat",
                                    }}>
                                    {section}
                                </h2>
                            ))}
                        </div>
                    </div>
                    <div className="px-6">
                        <div className="mt-4">
                            <h2 className="font-montserrat text-2xl font-medium-gray-900 mb-6"> Forex Remittances </h2>
                            <div className="rounded-3xl overflow-hidden shadow-lg bg-zinc-100">
                                <div className="overflow-x-auto relative">
                                    <table className="min-w-full table-auto">
                                        <thead>
                                            <tr className="text-center bg-sky-950 text-white">
                                                <th className={tableClass}>Transaction Date</th>
                                                <th className={tableClass}>Customer Name</th>
                                                <th className={tableClass}>Currency Name</th>
                                                <th className={tableClass}>FX Currency Remitted</th>
                                                <th className={tableClass}>Transaction Value (INR)</th>
                                                <th className={tableClass}>Margin (INR)</th>
                                                <th className={tableClass}>Agent Profit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {remittanceData.map((remittance, index) => (
                                                <tr key={index} className="border-b text-center">
                                                    <td className={rowClass}>{remittance.transactionDate}</td>
                                                    <td className={rowClass}>{remittance.customerName}</td>
                                                    <td className={rowClass}>{remittance.currencyName}</td>
                                                    <td className={rowClass}>{remittance.fxCurrencyRemitted}</td>
                                                    <td className={rowClass}>{remittance.transactionValue}</td>
                                                    <td className={rowClass}>{remittance.margin}</td>
                                                    <td className={rowClass}>{remittance.agentProfit}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <hr className="mt-6 mb-6 w-full" style={{ border: "none", height: "2px", background: "linear-gradient(to right, #FFFFFF 0%, #72AAD2 33%, #5E9DCB 66%, #FFFFFF 100%)" }} />
                        <div className="mt-10">
                            <h2 className="font-montserrat text-2xl font-medium-gray-900 mb-6">    Accommodation Bookings </h2>
                            <div className="rounded-3xl overflow-hidden shadow-lg bg-zinc-100">
                                <div className="overflow-x-auto relative">
                                    <table className="min-w-full table-auto">
                                        <thead>
                                            <tr className="text-center bg-sky-950 text-white">
                                                <th className={tableClass}>Customer Name</th>
                                                <th className={tableClass}>Country</th>
                                                <th className={tableClass}>Date of Booking</th>
                                                <th className={tableClass}>Margin (%)</th>
                                                <th className={tableClass}>Agent Profit</th>
                                                <th className={tableClass}>Generate Invoice</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {accommodationData.map((booking, index) => (
                                                <tr key={index} className="border-b text-center">
                                                    <td className={rowClass}>{booking.customerName}</td>
                                                    <td className={rowClass}>{booking.country}</td>
                                                    <td className={rowClass}>{booking.dateOfBooking}</td>
                                                    <td className={rowClass}>{booking.margins}</td>
                                                    <td className={rowClass}>{booking.agentProf}</td>
                                                    <td className="p-2"> <img
                                                        src={`${process.env.PUBLIC_URL}/images/desktop/tdesign_file-download.svg`}
                                                        alt="downloa-icon"
                                                        className="w-5 h-5 ml-2 cursor-pointer" /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="relative p-5 rounded-3xl w-full flex flex-col">
                        <img src={`${process.env.PUBLIC_URL}/images/desktop/tdesign_file-download.svg`} alt="file-all-download"
                            className="absolute right-6 top-1/2 transform -translate-y-1/2 cursor-pointer" />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PayoutsAccounts;